import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'
import Card from '../../../../components/card'

export const AvisoRecomendado = styled(Card)`
  margin-bottom: 16px;
`

export const CustomButton = styled(Button)`
  margin: auto;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    width: 100%;
    white-space: nowrap;
    max-width: 188px;
    order: 1;
  }
`

export const Paragraph = styled('p')`
  font-size: 16px;
  line-height: 20px;
  margin: 0px 0px 24px 0px;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 18px;
  }
`

export const Title = styled('p')`
  color: ${({ theme }) => theme.colors.secondary.normal};
  font-size: 18px;
  margin: 0px;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 24px;
  }
`

export const ModalBodyComponent = styled('div')`
  margin: 0 -36px;
  overflow: auto;
  max-height: 340px;
  background-color: ${({ theme }) => theme.colors.secondary.ultraLighten};
`

export const ModalBodyContainer = styled('div')`
  padding: 24px 24px 0px;
`

export const TitleAvisosRecomendados = styled('p')`
  font-size: 14px;
  line-height: 20px;
  margin: 0px 0px 20px 0px;
  font-weight: 600;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 16px;
  }
`

export const ModalFooterComponent = styled('div')`
  margin-bottom: -24px;
  margin-top: 24px;
`

export const ModalFooterContainer = styled('div')`
  text-align: center;
`
